var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-container',{attrs:{"custom":"100%"}},[(!_vm.is_page_loaded)?_c('app-spinner'):_vm._l((_vm.reservations_emails),function(email,index){return _c('app-email-list-multiple-recipient',{key:email.id,attrs:{"data":email,"count":index + 1}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }